<template>
    <div id="home-page">
        <modal v-if="modalComponent" @close-modal="closeModal">
            <component :is="modalComponent" :insuranceTypes="insuranceTypes" @close-modal="modalComponent = null"></component>
        </modal>
        <div class="nav-better-wrap" id="observable">
            <div class="nav-replacer" v-if="shouldNavPop && !isMobileMixin_isMobile"></div>
            <div class="filler" v-show="shouldNavPop && isMobileMixin_isMobile"></div>
            <landing-navigation :shouldNavPop="shouldNavPop" @open-modal="openModal" @logout="globalMixin_onLogout"></landing-navigation>
            <landing-block-better-way @open-modal="openModal" id="home"></landing-block-better-way>
        </div>
        <div class="how-it-works" :style="{'background-image': 'url(' + globalMixin_images.gornjiDesni + ')'}" id="how-it-works">
            <landing-block-how-it-works></landing-block-how-it-works>
        </div>
        <!-- <div class="how-we-make-money">
            <landing-block-how-we-make-money></landing-block-how-we-make-money>
        </div> -->
        <div class="how-fairwey-diff" id="how-we-diff">
            <img class="left-blob" :src="globalMixin_images.leftBlob" alt="">
            <img class="polygon" :src="globalMixin_images.polygon" alt="">
            <img class="graph" :src="globalMixin_images.graph" alt="">

            <landing-block-how-is-fairwey-different></landing-block-how-is-fairwey-different>
        </div>
        <div class="footer" id="footer">
            <register-footer></register-footer>
        </div>
    </div>
</template>

<script>
import LandingNavigation from '@/components/landing-page/LandingNavigation';
import LandingBlockBetterWay from '@/components/landing-page/LandingBlockBetterWay';
import LandingBlockHowItWorks from '@/components/landing-page/LandingBlockHowItWorks';
import LandingBlockHowWeMakeMoney from '@/components/landing-page/LandingBlockHowWeMakeMoney';
import LandingBlockHowIsFairweyDifferent from '@/components/landing-page/LandingBlockHowIsFairweyDifferent';
import LandingUserRegistration from '@/components/landing-page/LandingUserRegistration';
import LandingLogin from '@/components/landing-page/LandingLogin';
import RegisterFooter from '@/components/register-page/RegisterFooter';
import Modal from '@/components//Modal';

import { mapActions } from 'vuex';

export default {
  name: "LandingPage",
  components: {
    LandingNavigation,
    LandingBlockBetterWay,
    LandingBlockHowItWorks,
    LandingBlockHowWeMakeMoney,
    LandingBlockHowIsFairweyDifferent,
    LandingUserRegistration,
    LandingLogin,
    RegisterFooter,
    Modal,
  },
  data () {
    return {
      insuranceTypes: [],
      modalComponent: null,
      shouldNavPop: false,
    };
  },
  created () {
    this.getInsuranceTypes();
  },
  mounted () {
    this.observeInit();
    this.listenForOpenModal();
  },
  methods: {
    ...mapActions(['setIsLoggedIn']),
    async getInsuranceTypes () {
      const apiObj = {
        api: this.globalMixin_api.getInsuranceTypes,
      };
      const [data, error] = await this.globalMixin_apiCall(apiObj);
      if (!error) {
        this.insuranceTypes = data.data;
      }  
    },
    listenForOpenModal () {
      if (this.$route.params.openModal) this.openModal(this.$route.params.openModal);
    },
    openModal (type) {
      switch (type) {
        case 'register': this.modalComponent = 'LandingUserRegistration'; break;
        case 'login': this.modalComponent = 'LandingLogin'; break;
      }
    },
    observeInit () {
      const options = {
        root: null,
        rootMargin: '0px 0px -100%',
        threshold: 0,
      };

      const target = document.getElementById('observable');

      const callback = entries => {
        for (let i = 0; i < entries.length; i++) {
          this.shouldNavPop = !entries[i].isIntersecting;
        }
      };

      const observer = new IntersectionObserver(callback, options);
      observer.observe(target);
      // check if redirect needed
      if(sessionStorage.to){
        if(sessionStorage.to.includes('my-quotes')){
          this.openModal('login');
        } else {
          sessionStorage.removeItem('to');
        }
      }
    },
    closeModal () {
      if(sessionStorage.to){
        sessionStorage.removeItem('to');
      }
      this.modalComponent = null;
    },
  },
};
</script>
<style lang="scss" scoped>
#home-page {
  position:relative;
  $padding-inline: min(12vw, 12em);
  background-color: #FFF;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  > * {
    width: min(3840px, 100%);
    padding-left: $padding-inline;
    padding-right: $padding-inline;
  }
  .nav-better-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    // gap: 5em;
    // @include flex-gap(4em, 'column nowrap');
    padding-top: min(1.5vw, 1.5em);
    padding-bottom: min(5vw, 5em);
    background: url('../assets/images/greatF.png') no-repeat, linear-gradient(260.62deg, #5942E6 -0.28%, #3664D9 102.05%);
    //            ^^^^^^^ moralo je hardcoded jer dinamicki sa :style="{ 'background-image': 'url(' + globalMixin_images.greatF + ')' }" iz nekog razloga nije htelo
    .nav-replacer {
      height: $nav-height;
    }
    .filler{
      height: $nav-height;
      width: 100%;
    }
  }
  .how-it-works {
    display: flex;
    justify-content: center;
    padding-top: min(8vw, 8em);
    padding-bottom: min(5vw, 5em);
    background-repeat: no-repeat;
    background-position: right top;
  }
  .how-we-make-money {
    padding-top: min(3vw, 3em);
    padding-bottom: min(5vw, 5em);
  }
  .how-fairwey-diff {
    padding-top: min(3vw, 3em);
    padding-bottom: min(5vw, 5em);
    position: relative;
    .left-blob {
      left: 0;
      width: 1% important;
      display: inline-block;
      position:absolute
    }
    .graph{
      position: absolute;
      right: 10%;
    }
    .polygon{
      position: absolute;
      right: 5%;
      top: 15%;
    }
  }
  .footer {
    padding: 0;
    background: #4068DA;
  }
}

@media (max-width: 1070px) {
  #home-page {
    > * {
      padding-left: 4em;
      padding-right: 4em;
    }
  }
}

@media (max-width: 600px) {
  #home-page {
    > * {
      padding-left: 2em;
      padding-right: 2em;
    }
    .how-fairwey-diff{
      .graph{
        top: 10%;
      }
    }
  }
}

@media (max-width: 500px) {
  #home-page {
    .nav-better-wrap{
      // gap: 2em;
      // @include flex-gap(4em, 'column nowrap');
    }
  }
}

@media screen and (max-width: 280px){
  #home-page{
    .how-fairwey-diff{
      .graph{
        top: 12%;
      }
    }
  }
}

</style>
